/**
 * cn - Class name utility (Vue 2 equivalent of shadcn's cn)
 * Combines class names conditionally
 * 
 * Usage:
 * cn('base-class', condition && 'conditional-class', { 'object-class': true })
 */
export function cn(
  ...classes: Array<
    | string
    | undefined
    | null
    | false
    | Record<string, boolean>
    | Array<string | undefined | null | false>
  >
): string {
  return classes
    .filter(Boolean)
    .map((cls) => {
      if (typeof cls === 'string') return cls;
      if (Array.isArray(cls)) {
        return cls.filter(Boolean).join(' ');
      }
      if (typeof cls === 'object' && cls !== null) {
        return Object.entries(cls)
          .filter(([_, condition]) => Boolean(condition))
          .map(([className]) => className)
          .join(' ');
      }
      return '';
    })
    .filter(Boolean)
    .join(' ');
}

